import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { queryClient } from "./lib/queryClient";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // dropdowns in Header/ExportMenu
import "./index.css";

// Template §4. The provider order is FORCED, not stylistic:
//   QueryClientProvider outermost — AuthProvider calls queryClient.clear() on logout.
//   BrowserRouter above AuthProvider — the auth layer redirects and reads the current path.
//   AuthProvider above App — every route, guard and page calls useAuth().
//
// No React.StrictMode, deliberately: it double-invokes effects in development, which would double-fire
// the idle-logout listeners and the auth check, producing bugs that exist only in dev.
createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
